<template>
  <div>
    <div id="app" :keydown="handleKeyup">
      <ConfigProvider :locale="ja_JP">
        <!-- <keep-alive> -->
          <router-view></router-view>
        <!-- </keep-alive> -->
      </ConfigProvider>
    </div>
    <div class="app-spinner" v-if="loading">
      <a-spin :spinning="loading" size="large"/>
    </div>
  </div>
</template>

<script>
import { ConfigProvider } from 'ant-design-vue'
import jaJP from 'ant-design-vue/es/locale/ja_JP'
import moment from 'moment'
import _ from 'lodash'

moment.locale('ja')

export default {
  name: 'app',
  components: {
    ConfigProvider
  },
  setup() {
    return {
    }
  },
  data() {
    return {
      ja_JP: jaJP,
      loading: true,
      language: 'jp',
      popupRefresh: false,
      confirmReload: false
    }
  },
  mounted() {
    this.loading = false
    // wovnの状態の受け渡し
    window.addEventListener('wovnApiReady', () => {
      this.language = this.$wovn.getLang
    })
    window.addEventListener('wovnLangChanged', () => {
      this.language = this.$wovn.getLang
    })
    
    // 
    window.addEventListener('keydown', ($event) => {
      const context = this
      const fullUrlParams = {...this.$route.params, ...this.$route.query}
      if ($event.key === 'F5') {
        const onRefesh = _.get(this.$route.meta, 'onRefesh', {})
        const confirm = _.get(this.$route.meta, 'onRefesh.confirm', false)
        if (!confirm) {
          return true
        } else {
          if (!this.popupRefresh) {
            this.popupRefresh = true
            // open popup confirm
            this.$confirm({
              title: '前の画面に戻ります。よろしいでしょうか？',
              content: '',
              okText: 'はい',
              cancelText: 'いいえ',
              class: 'modal-confirm-custom',
              onOk() {
                context.popupRefresh = false
                switch(onRefesh.redirectOnConfirm) {
                case 'plan_details':
                  context.hrefUrlPlanDetails(fullUrlParams)
                  break
                }
              },
              onCancel() {
                context.popupRefresh = false
              }
            })
          }
          $event.preventDefault()
          return false
        }
      }
    })

    window.addEventListener("pagehide", () => {
      if(_.get(this.$route.meta, 'bs_app')){
        sessionStorage.setItem("bs_app", (JSON.stringify(this.$store.state.bs_app)));
      }
    }, false );

    window.onbeforeunload = ($event) => {
      // const onRefesh = _.get(this.$route.meta, 'onRefesh', {})
      const confirm = _.get(this.$route.meta, 'onRefesh.confirm', false)
      if (confirm) {
        $event.preventDefault()
        return false
      }

      if (this.confirmReload) {
        $event.preventDefault()
        return false
      }
    }

    window.addEventListener('resize', this.setScreen);
    this.setScreen();
  },
  watch: {
    '$store.state.loading'(loading) {
      this.loading = loading
    },
    '$store.state.confirmReload'(confirm) {
      this.confirmReload = confirm
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleKeyup($event) {
    },
    hrefUrlPlanDetails(params) {
      let url = `${location.protocol}//${location.host}/menus/${params.menuNo}/plans/${params.planId}/rooms/${params.roomId}`
      if (params.adultHeadCnt) {
        url += url.indexOf('?') > 0 ? `&adultHeadCnt=${params.adultHeadCnt}` : `?adultHeadCnt=${params.adultHeadCnt}`
      }
      if (params.checkInDate) {
        url += url.indexOf('?') > 0 ? `&checkInDate=${params.checkInDate}` : `?checkInDate=${params.checkInDate}`
      }
      if (params.stayNights) {
        url += url.indexOf('?') > 0 ? `&stayNights=${params.stayNights}` : `?stayNights=${params.stayNights}`
      }
      location.href = url
    },
    setScreen() {
        const width = window.innerWidth;
        const type = width < 639 ? 'mobile' : 'desktop';
        this.$store.commit('SET_SCREEN', type);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setScreen);
  }
}
</script>

<style>
@font-face {
  font-family: "Noto Sans JP";
  src: local("Merienda"),
   url(./assets/fonts/NotoSansJP-Regular.otf) format("truetype");
}
#app {
  font-family: "Noto Sans JP", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f2021;
  font-size: 14px;
}
.app-spinner {
  position: fixed;
  top: 0px;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(0 0 0 / 10%);
  z-index: 999999;
  transition: 1s;
}
</style>
